import { router } from '@inertiajs/react'
import { Upload } from 'lucide-react'
import { useRef } from 'react'
import { Button } from '@/components/ui/Button'
import { Label } from '@/components/ui/Label'
import { useRouteParams } from '@/hooks/useRoutes'
import routes from '@/routeHelpers'

interface ImageUploadFieldProps {
  label: string
  field: 'logo' | 'favicon' | 'hero_image' | 'og_image'
  currentUrl: string | null
  hint?: string
}

export function ImageUploadField({ label, field, currentUrl, hint }: ImageUploadFieldProps) {
  const { withAccount } = useRouteParams()
  const inputRef = useRef<HTMLInputElement>(null)

  const upload = (file: File) => {
    const formData = new FormData()
    formData.append(`help_center_setting[${field}]`, file)
    router.patch(routes.helpCenterSettings.update.path(withAccount()), formData, {
      preserveScroll: true,
      forceFormData: true,
    })
  }

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="flex items-center gap-3">
        <div className="flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-md border border-border bg-muted">
          {currentUrl
            ? <img src={currentUrl} alt={label} className="size-full object-contain" />
            : <Upload className="size-5 text-muted-foreground" />}
        </div>
        <div className="space-y-1">
          <Button type="button" variant="outline" size="sm" onClick={() => inputRef.current?.click()}>
            {currentUrl ? 'Replace' : 'Upload'}
          </Button>
          {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={e => { const file = e.target.files?.[0]; if (file) upload(file) }}
        />
      </div>
    </div>
  )
}
